<template>
  <div>
    <div class="share-header">
      <div class="m_share_btn">
        <div @click="copyLink()" class="circle-btn copy" />
      </div>
      <div class="m_share_btn">
        <!-- <div @click="showMail = !showMail" class="circle-btn email" /> -->
        <div @click="jobActionHandle('line')" class="circle-btn email" />
      </div>
      <div class="m_share_btn">
        <div @click="jobActionHandle('facebook')" class="circle-btn fb" />
      </div>
      <div class="m_share_btn">
        <div @click="jobActionHandle('linkedin')" class="circle-btn ld" />
      </div>
      <div class="m_share_btn">
        <Bookmark :id="id" />
      </div>
    </div>
  </div>
</template>

<script>
import Bookmark from '../search/Bookmark'
// import EmailForm from './EmailForm'

export default {
  components: {
    // EmailForm,
    Bookmark
  },
  props: {
    url: {
      default: null,
      type: String
    },
    id: {
      default: null,
      type: String
    }
  },
  data: function () {
    return {
      showMail: false
    }
  },
  methods: {
    cp: function (status) {
      if (status === 'sent' || status === 'close') {
        this.showMail = false
      }
    },
    copyLink() {
      // Effect
      window.alert('Copied')
      this.copied = true
      //  Copy
      const tempInput = document.createElement('input')
      tempInput.style = 'position: fixed; left: -1000px; top: -1000px'
      tempInput.value = this.url
      document.body.appendChild(tempInput)
      tempInput.select()
      document.execCommand('copy')
      document.body.removeChild(tempInput)
    },
    jobActionHandle: function (type) {
      const jobTitle = encodeURIComponent(document.title)
      // const jobId = $('#jobId').val()
      const jobLink = encodeURIComponent(this.url)
      switch (type) {
        case 'facebook':
          const faceLink = 'http://www.facebook.com/sharer.php?u=' + jobLink + '&t=' + encodeURIComponent(jobTitle)
          window.open(faceLink, '_blank', 'location=0,status=0,scrollbars=1,resizable=1,width=620,height=548')
          break
        case 'linkedin':
          // var twitterLink="http://twitter.com/home?status=Currently reading "+jobLink;

          const linkedinLink = 'http://www.linkedin.com/shareArticle?mini=true&url=' + jobLink + '&title=' +
              jobTitle + '&summary=&source=jiujik.com'
          window.open(linkedinLink, '_blank', 'location=0,status=0,scrollbars=1,resizable=1,width=820,height=548')
          break
        case 'weibo':
          const weiboLink = 'http://v.t.sina.com.cn/share/share.php?url=' + jobLink + '&title=' + jobTitle
          window.open(weiboLink, '_blank', 'location=0,status=0,scrollbars=1,resizable=1,width=595,height=548')
          break
        case 'google':
          const googleLink = 'http://www.google.com/reader/link?url=' + jobLink + '&title=' + jobTitle
          window.open(googleLink, '_blank', 'location=0,status=0,scrollbars=1,resizable=1,width=595,height=548')
          break
        case 'line':
          const linelink = 'https://social-plugins.line.me/lineit/share?url=' + jobLink + '&title=' + jobTitle
          window.open(linelink, '_blank', 'location=0,status=0,scrollbars=1,resizable=1,width=595,height=548')
          break
          // case 'recommend':
          //   window.open(generateUrl('search/recommend/' + jobId), '_self')

          //   break
        case 'print':
          window.print()
          break
      }
    }
  }
}

</script>

<style lang="scss">
  .share-header {
    font-size: 0;

    .m_share_btn {
      display: inline-block;
      width: 20%;
      height: 50px;
      text-align: center;
      vertical-align: top;

      .circle-btn {
        cursor: pointer;
        height: 40px;
        width: auto;
        position: relative;
        top: 5px;
        border-radius: 50%;
        margin: 0 auto;
        background-size: auto;
        background-position: center center;
        background-repeat: no-repeat;

        &.copy {
          background-image: url(/asset/image/icon/link.svg);
        }

        &.fb {
          background-image: url(/asset/image/icon/sh-fb.svg);
        }

        &.ld {
          background-image: url(/asset/image/icon/sh-linkedin.svg);
        }

        &.email {
          background-image: url(/asset/image/icon/sh-line.svg);
        }
      }

      .bookmark {
        position: relative;
        display: block;
        margin: 0 auto;
        transform: scale(1.3);
        top: 2px;
        right: auto;
        left: auto;
      }
    }
  }

  .mobile-email-wrapper {
    background: #E4E7F2;
    margin: 0 -30px;
    padding: 45px;
    position: relative;
    // top: -15px;
  }

  .email-form {
    height: auto;
  }

</style>
